import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import FilterInTable from "../../../../Manage/FilterInTable";
import styles from "./VipCustomerList.module.scss";

const VipCustomerList = () => {
  const tableData = [
    { customerId: '001', customerName: 'William John', email: 'loremipsum@gmail.com', phoneNo: '+1234567890', totalSpend: '$50,000', status: 'Active' },
    { customerId: '001', customerName: 'William John', email: 'loremipsum@gmail.com', phoneNo: '+1234567890', totalSpend: '$50,000', status: 'Active' },
    { customerId: '001', customerName: 'William John', email: 'loremipsum@gmail.com', phoneNo: '+1234567890', totalSpend: '$50,000', status: 'Active' },
    { customerId: '001', customerName: 'William John', email: 'loremipsum@gmail.com', phoneNo: '+1234567890', totalSpend: '$50,000', status: 'Active' },
    { customerId: '001', customerName: 'William John', email: 'loremipsum@gmail.com', phoneNo: '+1234567890', totalSpend: '$50,000', status: 'Active' },
  ];

  const columns = [
    { name: "Customer ID", selector: (row) => row.customerId, minWidth: "140px" },
    { name: "Customer Name", selector: (row) => row.customerName, minWidth: "160px" },
    { name: "Email", selector: (row) => row.email, minWidth: "180px" },
    { name: "Phone number", selector: (row) => row.phoneNo, minWidth: "160px" },
    { name: "Total Spend", selector: (row) => row.totalSpend, minWidth: "140px" },
    { name: "Status", selector: (row) => row.status },
    {
      name: "Action",
      cell: () => (
        <div className="d-flex gap-2">
          <button className={styles["action-button"]}>View</button>
          <button className={styles["action-button"]}>Edit</button>
        </div>
      ),
      minWidth: "120px"
    },
  ];

  return (
    <div className={styles["wrapper"]}>
      <FilterInTable componentName="Vip Customers List" />
      <div className="mt-3" />
      <DatatableComponent
        data={tableData}
        columns={columns}
        type="yellow-bordered"
        pagination
      />
    </div>
  );
};

export default VipCustomerList;